import { apiClient } from '../../../app/api/apiClient';
import type { Commission, CommissionSummary, CommissionsPage } from '../types/commission.types';

function filters(params: { representativeId?: string; mobile?: string; tenantId?: string }) {
  return {
    ...(params.representativeId ? { representative_id: params.representativeId } : {}),
    ...(params.mobile?.trim() ? { mobile: params.mobile.trim() } : {}),
    ...(params.tenantId ? { tenant_id: params.tenantId } : {}),
  };
}

export async function getCommissionSummary(params: Parameters<typeof filters>[0] = {}) {
  const response = await apiClient.get('/api/super-admin/commissions/summary', {
    query: filters(params),
  });
  return (response.data as { summary: CommissionSummary }).summary;
}

export async function getCommissions(
  page = 1,
  pageSize = 20,
  params: Parameters<typeof filters>[0] = {},
): Promise<CommissionsPage> {
  const response = await apiClient.get('/api/super-admin/commissions', {
    query: { page, page_size: pageSize, ...filters(params) },
  });
  const data = (response.data as { data: { commissions: Commission[]; page: number; limit: number; total: number } }).data;
  return {
    commissions: data.commissions,
    meta: { page: data.page, limit: data.limit, total: data.total },
  };
}

export async function getCommission(id: string): Promise<Commission> {
  const response = await apiClient.get(`/api/super-admin/commissions/${id}`);
  return (response.data as { commission: Commission }).commission;
}
